import { Component, OnInit, forwardRef, Input, EventEmitter, ViewEncapsulation, Output, Injector } from '@angular/core';
import { SearchAndSelect } from 'src/modules/base/components/form/models/serachselect.model';
import { QuestionControlService } from '../form/question-control.service';
import { BaseService } from '../../shared/services/base.service';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'resource-loader',
    templateUrl: './resource-loader.component.html',
    styleUrls: ['./resource-loader.component.css'],
    standalone: false
})

export class ResourceLoaderComponent implements OnInit {
  public config:any = {
    datasource:{
      "application": "account-management",
      "resource": "resource_master",
      "query_id": "GET_ALL",
      "key": "id",
      "search_columns":"resource_name",
      "filter": "facility_share_resource:true"
  },
    defaultsetting:{
        "singleSelection": true,
        "allowSearchFilter": true,
        "checkBoxRequired": false,
        "apliCall": true,
        "closeDropDownOnSelection":true
    },
    "currentAction":"LIST"
  };
  constructor(
    public baseService:BaseService,
    public route:ActivatedRoute,
    public injector:Injector,
    private qcs: QuestionControlService
    ) {

      var resource = this.route.snapshot.paramMap.get('resource');
      if(resource){
        this.config.resource = resource;
        this.changeResource({id:resource})
      }
  }
  ngOnInit(): void {
    //imliment permission here

    this.config.decorator = this.baseService.initDecorator("ResourceLoaderDecorator", this.route, this.injector);
    this.config.resourceDatasource = new SearchAndSelect({
      datasource: this.config.datasource,
      defaultsetting: this.config.defaultsetting,
      getterKey: 'resource_name',
      getterValue: 'resource_name',
      key: "resource_name",
      req_keys: ['resource_name']
    });
    this.config.fieldGroups = [{ questions: [this.config.resourceDatasource] }];
    this.config.form = this.qcs.toFormGroup(this.config.fieldGroups, 'modify');
  }

  changeResource(event){
    if(event){
      this.config.resourceName = event.id;
    }else{
      this.config.resourceName = "";
    }
  }

}
